export default props => (
  <div>
    <div className="ma-container content m-b-lg m-t-lg">
      { props.isActive && (
      <div className="scrolling-banner">
        <blockquote className="m-b-lg">
          <div dangerouslySetInnerHTML={{ __html: props.text }} />
        </blockquote>
        <div className="scrolling-banner_fade" />
      </div>
    ) }
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/ScrollingBanner/index.js